module.exports = __webpack_public_path__ + "static/media/checkin_intake.73607fc9.png";